import { z } from 'zod';
import { SUPPORT_REMINDER_MAILBOXES, SUPPORT_REMINDER_TRIGGERS, SUPPORT_REMINDER_TRIGGER_INFO, } from '../types/support-reminders.js';
const email = z.string().trim().toLowerCase().email('Enter a valid email address').max(254);
/** Settings → Auto reminder mail. Only what is sent changes; the password is write-only. */
export const SaveSupportReminderSettingsSchema = z.object({
    enabled: z.boolean().optional(),
    mailbox: z.enum(SUPPORT_REMINDER_MAILBOXES).optional(),
    channelId: z.string().uuid().nullable().optional(),
    smtpHost: z.string().trim().max(255).nullable().optional(),
    smtpPort: z.number().int().min(1).max(65_535).nullable().optional(),
    smtpUser: z.string().trim().max(255).nullable().optional(),
    /** A new password; leave out to keep the saved one, null to clear it. */
    smtpPassword: z.string().max(500).nullable().optional(),
    smtpSecure: z.boolean().optional(),
    fromAddress: email.nullable().optional(),
    fromName: z.string().trim().max(120).nullable().optional(),
});
export const SupportReminderRuleInputSchema = z
    .object({
    name: z.string().trim().min(1, 'Name the rule').max(120),
    isActive: z.boolean(),
    trigger: z.enum(SUPPORT_REMINDER_TRIGGERS),
    threshold: z.number().int().min(0).max(3650).nullable(),
    recipients: z.object({
        contacts: z.boolean(),
        accountManager: z.boolean(),
        projectManager: z.boolean(),
        extra: z.array(email).max(20),
    }),
    subject: z.string().trim().min(1, 'Write a subject').max(300),
    body: z.string().trim().min(1, 'Write the message').max(10_000),
})
    .refine((r) => SUPPORT_REMINDER_TRIGGER_INFO[r.trigger].threshold === null || r.threshold !== null, { message: 'Set the number for this condition', path: ['threshold'] })
    .refine((r) => r.recipients.contacts ||
    r.recipients.accountManager ||
    r.recipients.projectManager ||
    r.recipients.extra.length > 0, { message: 'Pick at least one recipient', path: ['recipients'] });
export const PreviewSupportReminderSchema = z.object({
    rule: SupportReminderRuleInputSchema,
    contractId: z.string().uuid(),
});
export const TestSupportReminderMailSchema = z.object({ to: email });
//# sourceMappingURL=support-reminders.schema.js.map